import { render, staticRenderFns } from "./ezIcon.vue?vue&type=template&id=b180b7e6&scoped=true"
import script from "./ezIcon.vue?vue&type=script&lang=js"
export * from "./ezIcon.vue?vue&type=script&lang=js"
import style0 from "./ezIcon.vue?vue&type=style&index=0&id=b180b7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b180b7e6",
  null
  
)

export default component.exports